/**
 * Card Component
 * Card component احترافي مثل SaaS apps
 */
import React from 'react';
import styled from 'styled-components';

const CardContainer = styled.div`
  background: ${props => props.theme.surfaceElevated || '#fff'};
  border: 1px solid ${props => props.theme.border || '#e0e0e0'};
  border-radius: ${props => props.theme.radius?.lg || '12px'};
  padding: ${props => props.padding || props.theme.spacing?.lg || '24px'};
  box-shadow: ${props => props.elevated ? props.theme.shadowMedium : props.theme.shadow || '0 2px 4px rgba(0,0,0,0.1)'};
  transition: all 0.2s ease;
  
  &:hover {
    ${props => props.hoverable && `
      box-shadow: ${props.theme.shadowLarge || '0 8px 16px rgba(0,0,0,0.15)'};
      transform: translateY(-2px);
    `}
  }
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${props => props.theme.spacing?.md || '16px'};
  padding-bottom: ${props => props.theme.spacing?.md || '16px'};
  border-bottom: 1px solid ${props => props.theme.border || '#e0e0e0'};
`;

const CardTitle = styled.h3`
  font-size: ${props => props.theme.fontSize?.lg || '18px'};
  font-weight: 600;
  color: ${props => props.theme.text || '#000'};
  margin: 0;
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing?.sm || '8px'};
`;

const CardBody = styled.div`
  color: ${props => props.theme.textSecondary || '#666'};
`;

const CardFooter = styled.div`
  margin-top: ${props => props.theme.spacing?.lg || '24px'};
  padding-top: ${props => props.theme.spacing?.md || '16px'};
  border-top: 1px solid ${props => props.theme.border || '#e0e0e0'};
  display: flex;
  justify-content: ${props => props.footerAlign || 'flex-end'};
  gap: ${props => props.theme.spacing?.sm || '8px'};
`;

export const Card = ({ 
  title, 
  icon, 
  children, 
  footer, 
  footerAlign,
  padding,
  elevated = false,
  hoverable = false,
  ...props 
}) => {
  return (
    <CardContainer 
      padding={padding}
      elevated={elevated}
      hoverable={hoverable}
      {...props}
    >
      {title && (
        <CardHeader>
          <CardTitle>
            {icon && icon}
            {title}
          </CardTitle>
        </CardHeader>
      )}
      <CardBody>
        {children}
      </CardBody>
      {footer && (
        <CardFooter footerAlign={footerAlign}>
          {footer}
        </CardFooter>
      )}
    </CardContainer>
  );
};

